import React from "react";
import classes from "./Header.scss";
import I18nHOC from "UIComponents/I18nHOC";
import { ToddleIcon, LeftIcon } from "SvgComponents";
import { onEnterOrSpaceKeyDown } from "Utils";

const Header = React.memo(props => {
  const { goToBack } = props;
  return (
    <div className={classes.container}>
      <div className={classes.leftContainer}>
        <div
          className={classes.absoluteContainer}
          role="button"
          tabIndex={0}
          aria-label="Go back"
          onClick={goToBack}
          onKeyDown={e => onEnterOrSpaceKeyDown(e, goToBack)}
        >
          <div className={classes.leftIcon}>
            <LeftIcon />
          </div>
          <ToddleIcon />
        </div>
        <div className={classes.detailContainer}>
          <div className={classes.title}>{`Users`}</div>
        </div>
      </div>
    </div>
  );
});

Header.displayName = "Header";

export default I18nHOC({ resource: [] })(Header);
